<div class="modal-dialog">
  <div mat-dialog-title class="dialog-title">
    <button mat-icon-button class="no-background" aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-dialog">
    <h4 class="non-cap small-margin">{{"gather.not-interested.let-us-know" | translate}}</h4>
      <p>{{"gather.not-interested.choose-all-that-apply" | translate}}</p>
    <form id="gather-not-interested-form" [formGroup]="formGroup">
      <div class="row medium-margin form-option">
          <div class="checkbox-container">
            @for (reason of notInterestedReasons; track reason) {
              <div formGroupName="notInterestedReasons">
                <mat-checkbox class="checkbox" [disableRipple]="true" [formControlName]="convertToCamelCase(reason)">
                  <label class="text checkbox-label">{{'gather.not-interested.reason.' + reason | translate}}</label>
                </mat-checkbox>
              </div>
            }
          </div>
      </div>
      <div class="info-container">
        <mat-icon>info</mat-icon>
        <small>{{"gather.not-interested.get-better-matches" | translate}}</small>
      </div>
      <div class="row medium-margin form-option">
          <button class="gather-modal-button" [disabled]="isSubmitDisabled()" (click)="onConfirm()">{{"gather.not-interested.continue-to-preferences" | translate}}</button>
      </div>
    </form>
  </mat-dialog-content>
</div>
